import { FIELD_KEYS } from '_constants/forms';

import {
  validateAddress,
  validateCVC,
  validateCardMonth,
  validateCardNumber,
  validateCardYear,
  validateConfirmation,
  validateEmail,
  validateEndDate,
  validateNewPassword,
  validatePhone,
  validateStartDate,
} from './validators';

export const RULES = {
  [FIELD_KEYS.firstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELD_KEYS.lastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELD_KEYS.username]: () => {
    return {
      required: 'Please provide Username / E-mail Address',
    };
  },
  [FIELD_KEYS.dateOfBirth]: () => {
    return {
      required: 'Please select Date',
    };
  },
  [FIELD_KEYS.ssn]: () => {
    return {
      required: 'Please enter SSN',
    };
  },
  [FIELD_KEYS.phone]: (options) => {
    return {
      required: 'Please provide Phone number',
      validate: validatePhone(options),
    };
  },
  [FIELD_KEYS.email]: (options) => {
    return {
      required: 'Please provide Email',
      pattern: {
        value:
          // eslint-disable-next-line no-useless-escape
          /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
        message: 'Email address is not valid',
      },
      validate: validateEmail(options),
    };
  },
  [FIELD_KEYS.address1]: (options) => {
    return {
      required: 'Please provide Address',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELD_KEYS.city]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELD_KEYS.state]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELD_KEYS.zip]: () => {
    return {
      required: 'Please provide zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELD_KEYS.password]: () => {
    return {
      required: 'Please provide Password',
      minLength: {
        value: 8,
        message: 'Password length should not be less than 8 characters',
      },
    };
  },
  [FIELD_KEYS.oldPassword]: () => {
    return {
      required: 'Please provide Current Password',
      minLength: {
        value: 8,
        message: 'Password length should not be less than 8 characters',
      },
    };
  },
  [FIELD_KEYS.newPassword]: (options) => {
    return {
      required: 'Please provide New Password',
      minLength: {
        value: 8,
        message: 'Password length should not be less than 8 characters',
      },
      validate: validateNewPassword(options),
    };
  },
  [FIELD_KEYS.confirmation]: (options) => {
    return {
      required: 'Please provide Confirmation',
      validate: validateConfirmation(options),
    };
  },
  [FIELD_KEYS.startDate]: (options) => {
    return {
      required: 'Please provide Start Date',
      validate: validateStartDate(options),
    };
  },
  [FIELD_KEYS.endDate]: (options) => {
    return {
      required: 'Please provide End Date',
      validate: validateEndDate(options),
    };
  },
  [FIELD_KEYS.description]: () => {
    return {
      required: 'Please provide description',
    };
  },
  [FIELD_KEYS.file]: () => {
    return {
      required: 'Please choose file to upload',
    };
  },
  [FIELD_KEYS.cardNumber]: (options) => {
    return {
      required: 'Please provide Card Number',
      validate: validateCardNumber(options),
    };
  },
  [FIELD_KEYS.cvc]: (options) => {
    return {
      required: 'Please provide CVC/CVV',
      pattern: {
        value: /[0-9]/i,
        message: 'CVC/CVV should contain only digits',
      },
      minLength: {
        value: 3,
        message: 'CVC/CVV should contain 3 or 4 digits',
      },
      maxLength: {
        value: 4,
        message: 'CVC/CVV should contain 3 or 4 digits',
      },
      validate: validateCVC(options),
    };
  },
  [FIELD_KEYS.cardMonth]: (options) => {
    return {
      required: 'Please enter Month',
      validate: validateCardMonth(options),
    };
  },
  [FIELD_KEYS.cardYear]: (options) => {
    return {
      required: 'Please enter Year',
      validate: validateCardYear(options),
    };
  },
  [FIELD_KEYS.returnToAmend]: () => {
    return {
      required: 'Please choose a return to amend',
    };
  },
  [FIELD_KEYS.reasonForAmendment]: () => {
    return {
      required: 'Please choose reason for amendment',
    };
  },
  [FIELD_KEYS.fileType]: () => {
    return {
      required: 'Please provide document type',
    };
  },
  [FIELD_KEYS.tags]: () => {
    return {
      required: 'Please enter tags',
      // validate: () => {},
    };
  },
  [FIELD_KEYS.accountName]: () => {
    return {
      required: 'Please select Account Name',
    };
  },
  [FIELD_KEYS.contactName]: () => {
    return {
      required: 'Please enter Contact Name',
    };
  },
  [FIELD_KEYS.total]: () => {
    return {
      required: 'Please enter Amount',
    };
  },
  [FIELD_KEYS.contactName]: () => {
    return {
      required: 'Please select Reference',
    };
  },
  [FIELD_KEYS.transactionType]: () => {
    return {
      required: 'Please select Type',
    };
  },
  [FIELD_KEYS.date]: () => {
    return {
      required: 'Please select Date',
    };
  },
  [FIELD_KEYS.reference]: () => {
    return {
      required: 'Please select Reference',
    };
  },

  //
  [FIELD_KEYS.spouseFirstName]: () => {
    return {
      required: 'Please provide Spouse First Name',
      pattern: {
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELD_KEYS.spouseLastName]: () => {
    return {
      required: 'Please provide Spouse Last Name',
      pattern: {
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELD_KEYS.spouseDateOfBirth]: () => {
    return {
      required: 'Please select Date',
    };
  },
  [FIELD_KEYS.spouseSsn]: () => {
    return {
      required: 'Please enter Spouse SSN',
    };
  },
  [FIELD_KEYS.spousePhone]: (options) => {
    return {
      // required: 'Please provide Spouse Phone number',
      validate: validatePhone(options),
    };
  },
  [FIELD_KEYS.spouseEmail]: (options) => {
    return {
      // required: 'Please provide Spouse Email',
      pattern: {
        value:
          // eslint-disable-next-line no-useless-escape
          /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
        message: 'Email address is not valid',
      },
      validate: validateEmail(options),
    };
  },
  [FIELD_KEYS.spouseAddress1]: (options) => {
    return {
      required: 'Please provide Spouse Address',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELD_KEYS.spouseCity]: () => {
    return {
      required: 'Please provide Spouse City Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELD_KEYS.spouseState]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELD_KEYS.spouseZip]: () => {
    return {
      required: 'Please provide Spouse zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELD_KEYS.year]: () => {
    return {
      required: 'Please select Year',
    };
  },
  [FIELD_KEYS.response]: () => {
    return {
      required: 'Please enter your response',
    };
  },
  [FIELD_KEYS.relationship]: () => {
    return {
      required: 'Please select Relationship',
    };
  },
};

export const getValidationRules = (fieldKey, options = {}) => {
  const getFieldRule = RULES[fieldKey];
  return getFieldRule ? getFieldRule(options) : undefined;
};
